<template>
  <v-app>
    <v-content class="v-content-ajust">
      <global-header />
      <globallogo />
      <div id="menu-top"></div>
      <!-- <global-menu /> -->
      <global-NewMenu />

      <transition name="page" mode="out-in">
        <router-view class="main" />
      </transition>

      <global-footer />
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable */
import globalHeader from "./components/global/headercompact.vue";
import globallogo from "./components/global/headerlogo.vue";
import globalNewMenu from "@/components/global/menunew.vue";
import globalFooter from "./components/global/footer.vue";
export default {
  name: "app",
  components: {
    globalHeader,
    globallogo,
    globalNewMenu,
    globalFooter
  },
  mounted() {
    this.$global();
  }
};
</script>
<style >
.v-content-ajust{
      padding: 25px 0px 0px !important;
}
</style>